import React from "react";
import { Box, Typography } from "@mui/material";

function Banner({ title }) {
  return (
    <Box
      sx={{
        backgroundColor: "transparent",
        color: "white",
        pt: "4px",
        textAlign: "center",
        width: "100%",
      }}
    >
      <Typography variant="body1" sx={{ color: "red", fontWeight: "bold" }}>
        {title}
      </Typography>
    </Box>
  );
}

export default Banner;
